import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'aux-ag-po-download',
  template: `
    <div class="flex font-medium space-x-2 text-aux-blue underline items-center justify-center">
      <span inlineSVG="download.svg"></span>
      <a href="#">Download PO</a>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgPoDownloadComponent implements ICellRendererAngularComp {
  refresh(): boolean {
    return false;
  }

  agInit(): void {}
}
